/**
 * KpiCard — Wiederverwendbare KPI-Karte fuer das Dashboard (Phase 4 Plan 03).
 *
 * Zeigt: Label oben, grosse Zahl in der Mitte, optionales Subtitle unten in Grau.
 * Optionaler Trend-Pfeil: > 0 gruen hoch, < 0 rot runter, = 0 grauer Strich.
 * Akzent-Border links via #E9FF57.
 *
 * CI: #1A1A1A Text, #E9FF57 Akzent, #DAD9D9 Border. NIE weiss auf Gelb.
 */

interface KpiCardProps {
  label: string;
  value: string | number;
  subtitle?: string;
  trend?: number;
}

export default function KpiCard({ label, value, subtitle, trend }: KpiCardProps) {
  const trendIcon = () => {
    if (trend === undefined || trend === null) return null;
    if (trend > 0) {
      return <span className="text-green-600 font-bold text-sm ml-1" title="Trend steigend">▲ {trend.toFixed(1)}%</span>;
    }
    if (trend < 0) {
      return <span className="text-red-600 font-bold text-sm ml-1" title="Trend fallend">▼ {Math.abs(trend).toFixed(1)}%</span>;
    }
    return <span className="text-gray-400 text-sm ml-1" title="Kein Trend">— 0%</span>;
  };

  return (
    <div className="rounded-lg border border-[#DAD9D9] bg-white shadow-sm p-4 border-l-4 border-l-[#E9FF57]">
      <p className="text-xs font-semibold text-[#1A1A1A] uppercase tracking-wide mb-1">{label}</p>
      <div className="flex items-baseline gap-1">
        <span className="text-3xl font-bold text-[#1A1A1A]">{value}</span>
        {trendIcon()}
      </div>
      {subtitle && (
        <p className="text-xs text-gray-500 mt-1">{subtitle}</p>
      )}
    </div>
  );
}
